import { Alert, Box, Button, Typography } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

function ErrorFallback() {
  const { t } = useTranslation();
  return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 3 }}><Alert severity="error" sx={{ maxWidth: 560 }}><Typography sx={{ fontWeight: 700 }}>{t('errors.title')}</Typography><Typography sx={{ mt: .5, mb: 2 }}>{t('errors.description')}</Typography><Button variant="outlined" color="error" onClick={() => window.location.reload()}>{t('common.retry')}</Button></Alert></Box>;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError(): { failed: boolean } { return { failed: true }; }
  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Application render failure', error, info);
    Sentry.captureReactException(error, info);
  }
  render(): ReactNode { return this.state.failed ? <ErrorFallback /> : this.props.children; }
}
